import { createGlobalStyle } from 'styled-components'
import { maxXs } from './breakPoints'

import './animate.min.css'

export default createGlobalStyle`
  *, p, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
    outline: 0 !important;
    box-sizing: border-box;
  }

  h1 {
    font-family: Arvo;
    font-size: 42px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #222222;

    @media (${maxXs}) {
      font-size: 24px;
      line-height: 1.25;
      text-align: center;
    }
  }

  h2 {
    font-family: Arvo;
    font-size: 32px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: center;
    color: #222222;

    @media (${maxXs}) {
      font-size: 24px;
    }
  }

  h3 {
    font-family: Arvo;
    font-size: 26px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #222222;

    @media (${maxXs}) {
      font-size: 18px;
      line-height: 1.17;
    }
  }

  h4 {
    font-family: proxima-nova;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    color: #222222;
  }

  span {
    font-family: proxima-nova;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #222222;
    
    
    @media (${maxXs}) {
      font-size: 16px;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
    }
  }

  p {
    font-family: proxima-nova;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: left;
    color: #222222;

    @media (${maxXs}) {
      font-size: 14px;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: left;
    }
  }
  
  /* html, body, #root {
    height: 100%;
    overflow-x: hidden;
  } */
  html { height: 100%; overflow: auto; }
  body { height: 100%; }

 
  body {
    -webkit-font-smoothing: antialiased;
  }

  nav {
  }

  body, input, button {
    font: 14px 'proxima-nova', sans-serif;
  }

  #root, ul {
    margin: 0 auto;
    padding: 0;
  }

  /* forms */
  button {
    cursor: pointer;
  }
`
